class SiblingNav {
  constructor() {
    this.nav = document.querySelector(".sibling-nav__inner");
    this.next = document.querySelector(".sibling-nav__next");
    this.prev = document.querySelector(".sibling-nav__prev");
    if (
      this.nav.querySelector(".sibling-nav__list").scrollWidth >=
      this.nav.clientWidth
    ) {
      this.initPosition();
      this.listen();
    } else {
      this.next.classList.add("hidden");
    }
  }

  initPosition() {
    const current = document.querySelector(".sibling-nav__item.current");
    if (current) {
      current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
      setTimeout(() => {
        const list = this.nav.querySelector(".sibling-nav__list");
        if (list.scrollLeft > 0) {
          this.prev.classList.remove("hidden");
        }
      }, 300);
    }
  }

  listen() {
    const list = this.nav.querySelector(".sibling-nav__list");
    if (list.scrollLeft > 0) {
      this.prev.classList.remove("hidden");
    }
    let scrollMax = 0;
    let scrollLength = window.innerWidth;
    let offset = 50;
    this.nav.addEventListener("click", (ev) => {
      scrollMax = list.scrollWidth - list.clientWidth;
      if (ev.target.classList.contains("sibling-nav__next")) {
        list.scrollLeft += list.clientWidth - offset;
        if (list.scrollLeft + list.clientWidth > 0) {
          this.prev.classList.remove("hidden");
        }
        if (list.scrollLeft + list.clientWidth >= scrollMax) {
          this.next.classList.add("hidden");
        }
      }
      if (ev.target.classList.contains("sibling-nav__prev")) {
        list.scrollLeft -= list.clientWidth;
        if (list.scrollLeft - list.clientWidth < 0 + offset) {
          this.prev.classList.add("hidden");
        }
        if (list.scrollLeft - list.clientWidth < scrollMax + offset) {
          this.next.classList.remove("hidden");
        }
      }
    });
  }
}

export default SiblingNav;
